import { PenNameField } from './PenNameField'
import { withPenNameField } from './withPenNameField'

const ConnectedPenNameField = withPenNameField(PenNameField)

export { ConnectedPenNameField as PenNameField }
